// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './components/Login';
import QueueDisplay from './components/QueueDisplay';
import ErrorBoundary from './components/ErrorBoundary'; // Import ErrorBoundary
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/queue" element={<QueueDisplay />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
}

export default App;